// @flow
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Link, Separator, Text } from 'trpc-react-native-ui';
import { PlanSummary, TaxFootnote } from '../../../../../components/common';
import I18n from '../../../../../lib/i18n';
import FormatService from '../../../../../lib/format';
import BonusDetails from '../BonusDetails/BonusDetails.container';
import theme from '../../../../../theme-config';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';

export type StateProps = {
  options: {
    creditable: Object[],
    service: Object[],
  },
  secondaryCharacteristicsOptions: Object[],
};

type Props = StateProps & {
  canEditOffer: boolean,
  confirmPlanType: string,
  displayPricesShownAreExclusiveOfTaxMessage: boolean,
  editPlanRoute: string,
  navigation: NavigationScreenProp<NavigationRoute>,
  price: number,
};

export const PlanDetails = ({
  canEditOffer,
  confirmPlanType,
  displayPricesShownAreExclusiveOfTaxMessage,
  editPlanRoute,
  navigation,
  options,
  price,
  secondaryCharacteristicsOptions,
}: Props) => {
  const styles = getStyles();
  const goToChoosePlan = () => navigation.navigate(editPlanRoute, { cannotGoBack: true });

  return (
    <View>
      <View>
        <View style={styles.planContainer}>
          {options ? (
            <PlanSummary options={options} secondaryCharacteristicsOptions={secondaryCharacteristicsOptions} />
          ) : (
            <Text style={styles.plan} testID="noOptionsText">
              {I18n.t('SignUp.ConfirmPlan.toBeChosenLater')}
            </Text>
          )}
        </View>
        <Separator noMargin />
      </View>
      {options && (
        <View testID="planTextInformationsView">
          <View style={styles.monthlyPlan}>
            <Text style={styles.monthlyPlanTitle}>{I18n.t('SignUp.ConfirmPlan.monthlyPlan')}</Text>
            <View>
              <Text style={styles.monthlyPlanPrice}>{FormatService.formatCentsToCurrency(price, true)}</Text>
              {canEditOffer && (
                <Link
                  text={I18n.t('SignUp.ConfirmPlan.editOffer')}
                  style={styles.editOfferLink}
                  onPress={goToChoosePlan}
                  testID="editOfferLink"
                />
              )}
            </View>
          </View>
          {displayPricesShownAreExclusiveOfTaxMessage && <TaxFootnote />}
          <Separator noMargin />
        </View>
      )}
      <BonusDetails confirmPlanType={confirmPlanType} />
    </View>
  );
};

const getStyles = () =>
  StyleSheet.create({
    editOfferLink: {
      color: theme.buttons.LINK.color,
      fontSize: 12,
      marginTop: 8,
    },
    monthlyPlan: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingVertical: 15,
    },
    monthlyPlanPrice: {
      color: theme.confirmPlanPriceColor,
      fontSize: 16,
      textAlign: 'right',
    },
    monthlyPlanTitle: {
      color: theme.signUpTextColor,
      fontSize: 16,
      fontWeight: '500',
    },
    plan: {
      color: theme.signUpDarkTextColor,
      fontSize: 20,
      fontWeight: '300',
    },
    planContainer: {
      backgroundColor: 'transparent',
      marginVertical: 17,
    },
  });
